import styled from 'styled-components';

import { PrimaryButton } from 'brand-guidelines/Buttons-styled-components';
import { TYPOGRAPHY } from 'brand-guidelines/typography';

export const PhoneNumberSubmitButton = styled(PrimaryButton)`
  align-self: stretch;
`;

export const Bolded = styled.span`
  ${TYPOGRAPHY.OPEN_SANS.bold}
`;
